import { Button, Modal } from "react-bootstrap";


const ModalView = ({title, message, shouldShow, onClose, confirmTitle, confirmVariant = "primary", onConfirm}:
	{title?:string, message?:string, shouldShow:boolean, onClose:()=>void, confirmTitle?:string, confirmVariant?:"primary"|"danger", onConfirm:()=>void}) => {

	return (
		<Modal show={shouldShow} onHide={onClose}>
			<Modal.Header closeButton>
				<Modal.Title>{title && title}</Modal.Title>
			</Modal.Header>
			<Modal.Body>{message && message}</Modal.Body>
			<Modal.Footer>
				<Button variant={confirmVariant} className={confirmVariant === "danger" ? "app-modal-sign-out-button" : undefined} onClick={onConfirm}>
					{confirmTitle && confirmTitle}
				</Button>
			</Modal.Footer>
      	</Modal>
	)
}

export default ModalView;